import { axiosConfig } from "axios/axios.config";
import Page from "dto/page";

class V1WebAuthorityService {
  getAuthorities(page: Page) {
    return axiosConfig.get("v1/web/addon?page=" + page.pageNumber + "&size=" + page.rowsPerPage + "&sort=" + page.sort + "&direction=" + page.direction.toUpperCase());
  }
}

export default new V1WebAuthorityService();